import { Link } from 'react-router-dom'
import BackgroundFX from '../components/backgroundFX'
import Logo from '../components/logo'
import ThemeToggle from '../components/themeToggle'

export default function LegalPage({ content }) {
  return (
    <div className="min-h-screen flex flex-col relative" style={{ background: 'var(--bg)' }}>
      <BackgroundFX />
      <ThemeToggle fixed />

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 py-12">
        <div className="card p-8 sm:p-12">
          <div className="flex items-center justify-between mb-8">
            <Link
              to="/register"
              className="text-xs font-medium px-3 py-1.5 rounded-lg transition-colors"
              style={{ color: 'var(--text-1)', background: 'var(--surface-2)', border: '1px solid var(--border)' }}
              onMouseOver={e => e.currentTarget.style.borderColor = 'var(--brand)'}
              onMouseOut={e  => e.currentTarget.style.borderColor = 'var(--border)'}
            >
              ← Back to Register
            </Link>
            <Link to="/register">
              <Logo size="nav" />
            </Link>
          </div>

          <h1 className="text-2xl font-bold mb-1" style={{ color: 'var(--text-1)' }}>{content.title}</h1>
          <p className="text-xs mb-8" style={{ color: 'var(--text-3)' }}>{content.effective}</p>

          <p className="text-sm leading-relaxed mb-8" style={{ color: 'var(--text-2)' }}>{content.intro}</p>

          <div className="space-y-7">
            {content.sections.map((section, i) => (
              <div key={i}>
                <h2 className="text-sm font-semibold mb-2" style={{ color: 'var(--text-1)' }}>
                  {section.heading}
                </h2>
                <div className="space-y-2">
                  {section.body.map((para, j) => (
                    <p key={j} className="text-sm leading-relaxed" style={{ color: 'var(--text-2)' }}>
                      {para}
                    </p>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
